// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2MPB5","col":"Table_col__1i2k8","fulfillmentStatus":"Table_fulfillmentStatus__2PG_U","emailCol":"Table_emailCol__2gpDl"};